import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ProfilehelperDD } from 'app/shared/common/helper/personaldetails-helper';
import { GetSetOperations } from 'app/shared/common/helper/profile';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ToastrService } from 'ngx-toastr';
import { GetOperations } from 'app/shared/common/helper/dropdown';
import { ToastBaseModel } from 'app/shared/common/toast-data-model';
import moment from 'moment-timezone';
import { Moment } from 'moment';
@Component({
  selector: 'app-official-details',
  templateUrl: './official-details.component.html',
  styleUrls: ['./official-details.component.scss']
})
export class OfficialDetailsComponent implements OnInit {
  twilightDetailsForm: any;
  empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
  organizationLists: any[];
  locationList: any[];
  roleList: any[];
  departmentList: any[];
  reportingtoList = [];
  startTimeList = [];
  profileId: any;
  objectId = this.parseService.instance.User.current().id;
  profileValue: any;
  tenantId = '';
  workModes = [
    {
      id: 1,
      name: 'office',
    },
    {
      id: 2,
      name: 'remote',
    },
    {
      id: 3,
      name: 'hybrid',
    }
  ];
  usersProfileId = undefined;
  public selectedTz: string;
  public tzNames: string[];
  public utcDate: moment.Moment;
  public tzDate: moment.Moment;
  industryId: any;
  isOfficialDetailsUpdated: boolean;
  constructor(
    private formBuilder: FormBuilder,
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
    private queryInterface: QueryInterface,
    private _helper: ProfilehelperDD,
    private profileInterface: GetSetOperations,
    private dateConvertor: DateConvertor,
    private toastr: ToastrService,
    private toastMessage: ToastBaseModel,
    private profileDropDown: GetOperations,
    private route: ActivatedRoute
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getLocation();
    this.getOrganization();
    this.getRole();
    this.getDepartment();
    this.reportingtoList = this._helper.reportingtoLists;
    (async () => {
      this.createForm();
      this.route.params.subscribe(async params => {
        if (params['id']) {
          this.usersProfileId = params['id'];
        }
      });
      await this.getUserByProfileID(this.usersProfileId);
      this.getTwilightDetails();
      this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
      this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
      this.industryId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.industryId);

      this.reportingtoList = this._helper.reportingtoLists;
      this.tzNames = moment.tz.names();
      // this.timeZoneChanged('America/New_York');
    })();
  }

  ngOnInit(): void {
    if (this.empRole !== 'Admin') {
      this.twilightDetailsForm.disable();
    }
    this.getDropDowns();
  }
  createForm(): void {
    const panRegex = '[A-Z]{5}[0-9]{4}[A-Z]{1}';
    this.twilightDetailsForm = this.formBuilder.group({
      organisationId: ['', Validators.required],
      locationId: ['', Validators.required],
      workMode: [''],
      timeZone: [],
      // seatNo: ['', Validators.required],
      seatNo: [''],
      // doj: ['', Validators.required],
      doj: [''],
      departmentId: ['', Validators.required],
      officialEmail: ['', [Validators.required, Validators.email]],
      // yearofExperiences: ['', Validators.compose([Validators.maxLength(2), Validators.max(99), Validators.required])],
      yearofExperiences: [''],
      // months: ['', Validators.compose([Validators.maxLength(2), Validators.max(11), Validators.required])],
      months: [''],
      gitUserId: [''],
      startTime: ['', Validators.required],
      roleId: ['', Validators.required],
      reporterId: ['', Validators.required],
      reportingDate: ['', Validators.required],
      // panNumber: ['', [Validators.minLength(10), Validators.pattern(panRegex)]],
      // salaryAccountNumber: [''],
      // personalAccountNumber: ['', Validators.minLength(12)]
    });
  }

  async getOrganization(): Promise<void> {
    const result = [];
    this.queryInterface.executeQuery(this.parseService, 'Organisation', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        const jsonText = JSON.stringify(results[i]);
        const organizationInfo = JSON.parse(jsonText);
        result.push({
          id: organizationInfo.objectId,
          name: organizationInfo.name
        });
      }
      this.organizationLists = result;
    });
  }

  async getLocation(): Promise<void> {
    const result = [];
    this.queryInterface.executeQuery(this.parseService, 'Location', [{ condition: 'equalTo', field: 'isActive', value: true }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
    { field: 'name', condition: 'descending' }]).then(results => {
      for (let i = 0; i < results.length; i++) {
        const jsonText = JSON.stringify(results[i]);
        const locationInfo = JSON.parse(jsonText);
        result.push({ id: locationInfo.objectId, name: locationInfo.name });
      }
      this.locationList = result;
    });
  }

  async getRole(): Promise<void> {
    const result = [];
    this.queryInterface.queryRole(this.parseService)
      .then(results => {
        for (let i = 0; i < results.length; i++) {
          const jsonText = JSON.stringify(results[i]);
          const roleInfo = JSON.parse(jsonText);
          if (roleInfo.displayName) {
            result.push({ id: roleInfo.role.objectId, name: roleInfo.displayName });
            this.roleList = result;
          }
          else {
            result.push({ id: roleInfo.objectId, name: roleInfo.name });
            this.roleList = result;
          }
        }
      });
  }

  async getDepartment(): Promise<void> {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'TenantDepartment',
      [{ condition: 'equalTo', field: 'tenantId', value: this.tenantId }]).then(results => {
        if (results.length > 0) {
          for (let department of results) {
            result.push({
              id: department.get('department').id,
              name: department.get('displayName'),
            });
          }
          this.departmentList = result;
        }
        else {
          this.queryInterface.executeQuery(this.parseService, 'Department', [{ condition: 'equalTo', field: 'isActive', value: true },
          { field: 'name', condition: 'descending' }]).then(results => {
            for (let i = 0; i < results.length; i++) {
              let jsonText = JSON.stringify(results[i]);
              let departmentInfo = JSON.parse(jsonText);
              result.push({
                id: departmentInfo.objectId,
                name: departmentInfo.name
              });
            }
            this.departmentList = result;
          });
        }
      });
  }

  getTwilightDetails(): void {
    this.queryInterface.executeQuery(this.parseService, 'User', [{ condition: 'equalTo', field: 'objectId', value: this.objectId },
    { condition: 'include', value: 'profile' }]).then(result => {
      const results = result[0];
      const jsonText = JSON.stringify(results);
      const userProfile = JSON.parse(jsonText);
      this.profileValue = userProfile.profile;
      this.profileId = this.profileValue.objectId

      if (this.profileValue.officialInfo.experience === undefined) {
        this.profileValue.officialInfo.experience = { year: '', month: '' };
      }
      this.twilightDetailsForm.patchValue({
        locationId: this.profileValue.location === undefined ? '' : this.profileValue.location.objectId,
        workMode: this.profileValue.workMode,
        timeZone: this.profileValue.timeZone,
        organisationId: this.profileValue.organisation === undefined ? '' : this.profileValue.organisation.objectId,
        departmentId: this.profileValue.department === undefined ? '' : this.profileValue.department.objectId,
        roleId: this.profileValue.role === undefined ? '' : this.profileValue.role.objectId,
        reporterId: this.profileValue.reportingTo === undefined ? '' : this.profileValue.reportingTo.objectId,
        seatNo: this.profileValue.officialInfo.seatNo,
        reportingDate: this.profileValue.officialInfo.reportingDate,
        doj: this.profileValue.officialInfo.doj,
        officialEmail: this.profileValue.officialInfo.officialEmail,
        gitUserId: this.profileValue.officialInfo.gitUserId,
        // billableStatus: this.profileValue.billableStatus,
        yearofExperiences: this.profileValue.officialInfo.experience.year === undefined ? 0 : this.profileValue.officialInfo.experience.year,
        months: this.profileValue.officialInfo.experience.month === undefined ? 0 : this.profileValue.officialInfo.experience.month,
        startTime: this.profileValue.officialInfo.startTime,
        // panNumber: this.profileValue.officialInfo.panNumber,
        // salaryAccountNumber: this.profileValue.officialInfo.salaryAccountNumber,
        // personalAccountNumber: this.profileValue.officialInfo.personalAccountNumber
      });
      if (this.twilightDetailsForm.valid) {
        this.isOfficialDetailsUpdated = true;
      }
    });
  }
  /*
** ==========================================================
** Twilight Details Save Function
** ==========================================================
*/
  twilightDetailsSave(): void {
    // alert('disable');
    // return ;
    const profileValues = this.twilightDetailsForm.value;
    const reportingDate = profileValues.reportingDate ? this.dateConvertor.addGMTOffset(new Date(profileValues.reportingDate)).toISOString() : null;
    const doj = profileValues.doj ? this.dateConvertor.addGMTOffset(new Date(profileValues.doj)).toISOString() : null;
    const data = {
      officialInfo: {
        seatNo: profileValues.seatNo,
        reportingDate: reportingDate,
        doj: doj,
        officialEmail: profileValues.officialEmail,
        experience: {
          year: profileValues.yearofExperiences,
          month: profileValues.months
        },
        gitUserId: profileValues.gitUserId,
        startTime: profileValues.startTime,
        // panNumber: profileValues.panNumber,
        // salaryAccountNumber: profileValues.salaryAccountNumber,
        // personalAccountNumber: profileValues.personalAccountNumber

      }
    };
    if (this.twilightDetailsForm.valid) {
      this.profileInterface.updateProfile(this.profileId, data, profileValues, this.locationList, this.organizationLists, this.departmentList, this.roleList, this.reportingtoList);
      if (this.twilightDetailsForm) {
        this.toastr.success(this.toastMessage.Update);
      } else {
        this.toastr.success(this.toastMessage.Save);
      }
    }
  }


  async getDropDowns() {
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    let result = await query.find();
    var dropdownresults = result[0],
      profileDropDownValue = this.profileDropDown.getProfileDropDown(
        dropdownresults
      ),
      startTimeObj = this.startTimeList,
      startTimeList = profileDropDownValue.startTime;
    for (var i = 0; i < startTimeList.length; i++) {
      startTimeObj.push(startTimeList[i]);
    }
  }

  async getUserByProfileID(profileId): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (!profileId) {
        reject(this.objectId);
      }
      const UserClass = new this.parseService.instance.Query('User');
      UserClass.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
      let user = await UserClass.find();
      if (user.length) {
        user = user[0];
        this.objectId = user.id;
        resolve(this.objectId);
      } else {
        reject(this.objectId);
      }
    });
  }


  keyPress(event: any) {
    const pattern = /[0-9\+\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  handleAdmDateChange(event: any) {
    let date = this.dateConvertor.addGMTOffset(new Date(event.value)).toISOString();

    let todayDate = new Date();
    let joiningDate = new Date(date);

    let year = 0;
    let month = 0;

    if ((joiningDate.getMonth() + 1) > (todayDate.getMonth() + 1)) {
      let y = todayDate.getFullYear() - joiningDate.getFullYear();
      year = y - 1;
      let mo = (joiningDate.getMonth() + 1) - (todayDate.getMonth() + 1);
      month = (12 - mo) - 1;
    }
    else if ((joiningDate.getMonth() + 1) == (todayDate.getMonth() + 1)) {
      year = todayDate.getFullYear() - joiningDate.getFullYear();
    }
    else {
      year = todayDate.getFullYear() - joiningDate.getFullYear();
      month = (12 - ((todayDate.getMonth() + 1) - (joiningDate.getMonth() + 1))) - 1;
    }

    this.twilightDetailsForm.get('yearofExperiences').setValue(year);
    this.twilightDetailsForm.get('months').setValue(month);

  }

}
